import React from 'react'
import { withIcon } from '../../withIcon'

function ChevronLeftIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.553 5.35025C15.8049 5.6022 15.8049 6.01069 15.553 6.26264L9.81562 12L15.553 17.7373C15.8049 17.9893 15.8049 18.3978 15.553 18.6497C15.301 18.9017 14.8925 18.9017 14.6406 18.6497L8.44703 12.4562C8.19508 12.2042 8.19508 11.7957 8.44703 11.5438L14.6406 5.35025C14.8925 5.0983 15.301 5.0983 15.553 5.35025Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ChevronLeftIcon)
